<template>
  <div class="zoox-component zoox-action-card-template" :class="{scrolless}">
    <h3 class="template-title" :style="{color: dark ? 'white' : null}">
      {{ title }}
    </h3>
    <div class="template-actions">
      <!-- @slot Onde são colocadas as ações -->
      <slot name="actions" />
    </div>

    <slot name="card">
      <div v-if="noBackgroundCard" class="template-content">
        <component :is="contentWrapperComponent" class="scolless-content">
          <!-- @slot Conteúdo da página (dentro do card) -->
          <slot name="content" />
        </component>
      </div>
      <z-card
        v-else
        ref="card"
        class="template-content"
        :class="{scrolless}"
        height="100%"
        width="100%"
      >
        <template #content>
          <component :is="contentWrapperComponent" class="scolless-content">
            <!-- @slot Conteúdo da página (dentro do card) -->
            <slot name="content" />
          </component>
        </template>
      </z-card>
    </slot>
  </div>
</template>

<script>
/**
 * Componente de template de página, que é utilizado para construir a estrutura
 * da página. Normalmente vai ser o "esqueleto" de uma página completa, sendo necessário adicionar somente
 * o conteúdo através da utilização dos slots. Esse template ja segue um padrão de
 * espaçamentos padrões do design system, o que faz com que as telas tenham consistência entre elas.
 * @displayName Card Template
 * @private
 */
export default {
  name: 'ZCardTemplate',
  props: {
    /**
     * Título da página
     */
    title: {
      type: String,
      default: '',
    },
    /**
     * Flag para indicar que não deve adicionar o card
     */
    noBackgroundCard: {
      type: Boolean,
      default: false,
    },
    /**
     * Não permite scroll lateral
     */
    scrolless: {
      type: Boolean,
      default: false,
    },
    /**
     * Flag para indicar que o fundo é dark
     */
    dark: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    contentWrapperComponent() {
      return this.scrolless ? 'z-scrollbar' : 'div'
    },
  },
  methods: {
    /**
     * Retora a altura total do card
     * para fins de ter que utilizar algo em pixels
     *
     * @public
     */
    getCardHeight() {
      if (this.$refs.card) {
        return this.$refs.card.$el.clientHeight
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.zoox-action-card-template {
  display: grid;
  grid-template-areas:
    'title actions'
    'content content';
  grid-template-columns: auto 1fr;
  grid-template-rows: auto 1fr;
  row-gap: 12px;
  padding: 15px;
  min-height: calc(100vh - 48px);

  &.scrolless {
    height: calc(100vh - 48px);
    max-height: calc(100vh - 48px);
  }
}

.scolless-content {
  height: 100%;
}

.template-content {
  grid-area: content;

  &.scrolless {
    overflow-y: auto;
  }
}

.template-actions {
  justify-self: flex-end;
  grid-area: actions;

  display: flex;

  > * {
    margin-left: 5px;
    margin-right: 5px;
  }
}

.template-title {
  grid-area: title;
}
</style>
